export type Tier = {
  id: string;
  name: string;
  seats: string;
  qualification: string;
  benefits: string;
  highlight?: boolean;
};

// 職級（主席 → 理事），以卡片形式展示
export const tiers: Tier[] = [
  {
    id: "chairman",
    name: "主席",
    seats: "1",
    qualification: "產品廠家、深知皮膚治療專家",
    benefits: "全球品牌背書、標準制定權、全球分會資源調配，招商、教授治療技術和產品、傳至世界。",
    highlight: true,
  },
  {
    id: "vice-chairman",
    name: "副主席",
    seats: "1",
    qualification: "痛症專家-百症骨傷 / 副教授",
    benefits: "開拓國外渠道，以治療皮膚技術和痛症技術令有需要的人群受益，開拓業務、招商，提供資源、物料採購和供應系統。",
  },
  {
    id: "secretary-general",
    name: "秘書長",
    seats: "1",
    qualification: "海外業務資源機構企業",
    benefits: "中國、香港及海外開拓及連繫資源，增加分店成立，拓展技術至世界傳承，開拓業務、招商。",
  },
  {
    id: "deputy-secretary-general",
    name: "副秘書長",
    seats: "1",
    qualification: "超過 15 人公司的老闆",
    benefits: "開拓業務、招商，賺更多錢、更多人；學會運營制定權、活動主導權、導師認證資格。",
  },
  {
    id: "president",
    name: "會長",
    seats: "1 - 10",
    qualification: "店舖老闆、學院老闆",
    benefits: "技術升級優先權、會長理事專屬社群、活動代理權、導師認證資格，經審核後可加入其他課程，能力提升至國際級別。",
  },
  {
    id: "vice-president",
    name: "副會長",
    seats: "20 - 50",
    qualification: "店舖老闆",
    benefits: "參加國際展會找尋更多商機，導師培訓、進階專家，參加高層次圈子，經審核後可加入其他課程。",
  },
  {
    id: "director",
    name: "理事",
    seats: "100 - 500",
    qualification: "有意學習或已有相關美業任何技術的人士",
    benefits: "品牌建立、線上推廣、異業聯盟資源，共享招生、招商，品牌代理，來香港工作機會。",
  },
];

// 會員職級，以表格形式展示
export const memberTier: Tier = {
  id: "member",
  name: "會員",
  seats: "500",
  qualification: "從業者或愛好者",
  benefits: "資訊獲取、課程折扣、會員活動參與。",
};